<img #el [src]="src" *ngIf="src">
